import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  ReactNode,
} from "react";
import Toast from "../components/Toast/Toast";
import checkIcon from "../components/Toast/Image/check.svg";
import errorIcon from "../components/Toast/Image/error.svg";

type ToastType = "success" | "error" | "warning";

interface ToastMessage {
  id: number;
  description: string;
  backgroundColor: string;
  icon: string;
}

interface ToastContextData {
  showToast: (type: ToastType, description: string) => void;
}

const ToastContext = createContext<ToastContextData | undefined>(undefined);

export const ToastProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [list, setList] = useState<ToastMessage[]>([]);

  const showToast = useCallback((type: ToastType, description: string) => {
    const id = Math.floor(Math.random() * 101 + 1);

    let toastProperties: ToastMessage = {
      id,
      description,
      backgroundColor: "",
      icon: "",
    };

    switch (type) {
      case "success":
        toastProperties = {
          ...toastProperties,
          backgroundColor: "#5cb85c",
          icon: checkIcon,
        };
        break;
      case "error":
        toastProperties = {
          ...toastProperties,
          backgroundColor: "#d72828",
          icon: errorIcon,
        };
        break;
      case "warning":
        toastProperties = {
          ...toastProperties,
          backgroundColor: "#f0ad4e",
          icon: errorIcon,
        };
        break;
    }

    setList((prev) => [...prev, toastProperties]);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Toast toastList={list} autoDelete={true} />
    </ToastContext.Provider>
  );
};

export const useToast = (): ToastContextData => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast deve ser usado dentro de um ToastProvider");
  }
  return context;
};
